// Translations
import landing from '../views/landing/translations/de'

// Translation: Terms of service (German)
export default Object.freeze({
	name: '',
	views: { landing }
})
